module.exports = __webpack_public_path__ + "static/media/open-highway.d3963db8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/open-highway.png
// module id = 191
// module chunks = 0